{
  "common": {
    "entityTypes": {
      "User": "Benutzer",
      "Department": "Abteilung",
      "Role": "Stelle",
      "Process": "Prozess",
      "ProcessStepRecording": "Prozessschritt-Aufzeichnung",
      "ProcessStepAssignment": "Prozessschritt-Zuweisung",
      "Survey": "Umfrage",
      "Artifact": "Unterlage",
      "ExternalContact": "Externer Kontakt",
      "SoftwareSystem": "Softwaresystem",
      "OrgFunction": "Funktion",
      "Organization": "Organisation",
      "BliksyGeneration": "Bliksy-Generierung",
      "ProcessConnection": "Prozessverbindung",
      "ProcessChain": "Prozesskette",
      "ProcessMapPosition": "Prozesskarten-Position",
      "ProcessMapLaneDimension": "Prozesskarten-Bahndimension",
      "Tenant": "Mandant",
      "AppRegistry": "App-Registry",
      "PlatformSettings": "Plattform-Einstellungen"
    },
    "itemsSelected": "{{count}} ausgewählt",
    "selectAll": "Alle auswählen",
    "showMore": "Mehr anzeigen",
    "showLess": "Weniger anzeigen",
    "deleted": "gelöscht",
    "viewAll": "Alle anzeigen",
    "noItemsFound": "Keine Elemente gefunden",
    "Yes": "Ja",
    "No": "Nein",
    "Back": "Zurück",
    "back": "Zurück",
    "Done": "Fertig",
    "Beta": "Beta",
    "Save": "Speichern",
    "Remove": "Entfernen",
    "Edit": "Bearbeiten",
    "Search": "Suchen",
    "Create": "Erstellen",
    "Continue": "Weiter",
    "continue": "Weiter",
    "Submitting": "Wird gesendet...",
    "submit": "Absenden",
    "Settings": "Einstellungen",
    "Logout": "Abmelden",
    "loading": "Lädt...",
    "chatError": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "retry": "Erneut versuchen",
    "download": "Herunterladen",
    "trialDaysLeft": "Testphase endet in {{days}} Tagen",
    "trialLastDay": "Testphase endet heute",
    "trialExpired": "Testphase ist abgelaufen",
    "ErrorBoundary": {
      "title": "Etwas ist schief gelaufen",
      "description": "Beim Laden dieser Seite ist ein Fehler aufgetreten. Du kannst es erneut versuchen oder über die Seitenleiste zu einer anderen Seite navigieren.",
      "tryAgain": "Erneut versuchen",
      "goToSettings": "Zu Einstellungen",
      "goHome": "Zur Startseite",
      "viewErrorDetails": "Fehlerdetails anzeigen"
    },
    "NotFound": {
      "title": "Funktion in Kürze verfügbar",
      "description": "Wir arbeiten aktiv an dieser Funktion. Sie wird bald verfügbar sein!",
      "suggestion": "Erkunde in der Zwischenzeit andere Funktionen oder sieh dir unsere Roadmap an, um zu erfahren, was als Nächstes kommt.",
      "goToDashboard": "Zum Dashboard",
      "goToLogin": "Zur Anmeldung",
      "viewRoadmap": "Roadmap ansehen"
    },
    "Apps": {
      "notFound": "App nicht gefunden oder für diese Organisation nicht verfügbar.",
      "manageTitle": "App-Katalog",
      "manageDescription": "Apps deiner Organisation aktivieren und Plätze vergeben",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "activation": "Aktivierung",
      "enableSuccess": "App erfolgreich aktiviert.",
      "enableFailed": "Fehler beim Aktivieren der App.",
      "disableSuccess": "App erfolgreich deaktiviert.",
      "disableFailed": "Fehler beim Deaktivieren der App.",
      "seatsTitle": "App-Plätze",
      "seatsMembers": "Personen mit Zugriff",
      "seatsSaved": "Plätze gespeichert.",
      "seatDataIntro": "Ein Platz gewährt in dieser App vollen Lesezugriff auf: {{categories}}.",
      "seatDataCategories": {
        "processes": "Prozesse",
        "processSteps": "Prozessschritt-Details inkl. Notizen, Kapazitäts- und Kostendaten",
        "surveys": "Umfrageantworten inkl. einzelner Schrittbewertungen und Kommentare, Fallhäufigkeit und Bearbeitungsdauer – für alle Prozesse, unabhängig von der Abteilung",
        "systems": "Systeme",
        "roles": "Funktionen",
        "teams": "Teams",
        "departments": "Abteilungen",
        "orgMembers": "Mitgliederverzeichnis (inkl. E-Mail und Status)",
        "artifacts": "Unterlagen",
        "externalContacts": "Externe Kontakte (inkl. E-Mail)",
        "processChains": "Prozessketten (inkl. der verknüpften Prozesse)"
      },
      "notAllowed": "Nicht erlaubt",
      "notAllowedNotice": "Diese App ist für deine Organisation nicht erlaubt.",
      "seatsCount": "{{used}} / {{limit}} Plätze",
      "seatsNeedEnabledApp": "Plätze lassen sich erst vergeben, wenn die App aktiviert ist.",
      "seatsOverLimit": "{{over}} über dem Limit",
      "seatsNoCapacity": "Keine Plätze vorhanden",
      "category": {
        "analysis": "Analyse",
        "dataCapture": "Datenerfassung",
        "sales": "Vertrieb"
      }
    },
    "Sidebar": {
      "Dashboard": "Dashboard",
      "ActiveMonitoring": "Active Monitoring",
      "ComingSoon": "Demnächst verfügbar",
      "ensureContinuity": "Active Monitoring sichert deine Geschäftskontinuität.",
      "AreTheRelevant": "Sind alle relevanten Prozessmitglieder aktuell verfügbar?",
      "areThereBottleneck": "Gibt es Engpässe in deiner Prozesslandschaft?",
      "LearnMore": "Mehr erfahren",
      "Processes": "Prozesse",
      "AllProcesses": "Alle Prozesse",
      "MyTasks": "Meine Aufgaben",
      "ProcessLandscape": "Prozesslandkarte",
      "ProcessChains": "Prozessketten",
      "ProcessEditor": "Prozesseditor",
      "Organization": "Organisation",
      "MyDepartment": "Meine Abteilung",
      "MyOrgFunctions": "Meine Funktionen",
      "MySystems": "Meine Systeme",
      "Systems": "Systeme",
      "OrgCatalogs": "Organisationskataloge",
      "AllDepartments": "Alle Abteilungen",
      "AllFunctions": "Alle Funktionen",
      "AllTeams": "Alle Teams",
      "AllMembers": "Alle Personen",
      "AllSoftwareSystems": "Alle Softwaresysteme",
      "SystemLandscape": "Systemlandschaft",
      "AllExternalContacts": "Alle externen Kontakte",
      "AllArtifacts": "Alle Unterlagen",
      "OrgChart": "Organigramm",
      "Analytics": "Analysen",
      "AiUsage": "KI-Nutzung",
      "SeeWhichPeople": "Sieh, welche Personen oder Systeme in deinen Prozessen kritisch sind, wo ist das größte Verbesserungspotenzial?",
      "Survey": "Umfrage",
      "Apps": "Apps",
      "ManageApps": "Apps verwalten",
      "DataSync": "Datenabgleich",
      "needSpecificDetail": "Benötigst du spezifische Details zu bestimmten Prozessen? Wer ist der Experte dafür? Müssen Fragen zur Nachhaltigkeit beantwortet werden?",
      "Settings": "Einstellungen",
      "OrgSettings": "Organisationseinstellungen",
      "UserManagement": "Benutzerverwaltung",
      "TenantManagement": "Mandantenverwaltung",
      "InitialConfig": "Erstkonfiguration",
      "SoftwareSystems": "Softwaresysteme",
      "MyOverview": "Mein Arbeitsumfeld",
      "RecordingDashboard": "Aufnahme-Cockpit",
      "AuditLogs": "Audit-Protokolle",
      "ShadowSystems": "Schatten-Systeme",
      "Help": "Hilfe",
      "PartnerContent": "Partner-Inhalte",
      "AccountManagement": "Konten"
    },
    "Name": "Name",
    "Email": "E-Mail",
    "Logo": "Logo",
    "Change": "Ändern",
    "Upload": "Hochladen",
    "Created": "Erstellt",
    "Description": "Beschreibung",
    "Details": "Details",
    "Category": "Kategorie",
    "Type": "Typ",
    "Status": "Status",
    "FirstName": "Vorname",
    "LastName": "Nachname",
    "Actions": "Aktionen",
    "edit": "Bearbeiten",
    "actions": "Aktionen",
    "viewDetail": "Details anzeigen",
    "clone": "Duplizieren",
    "Updated": "Aktualisiert",
    "UserTypes": "Benutzertypen",
    "Classification": "Klassifizierung",
    "DepartmentManager": "Abteilungsleiter",
    "Error": "Fehler",
    "errorOccurred": "Ein Fehler ist aufgetreten",
    "success": "Erfolgreich",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "processing": "Verarbeitung...",
    "sending": "Wird gesendet...",
    "delete": "Löschen",
    "create": "Erstellen",
    "confirmDelete": "Löschen bestätigen",
    "confirmDeleteDescription": "Bist du sicher, dass du {{entity}} löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "unsavedChanges": "Ungespeicherte Änderungen",
    "unsavedChangesDescription": "Du hast ungespeicherte Änderungen. Möchtest du wirklich schließen?",
    "stay": "Weiter bearbeiten",
    "discardChanges": "Änderungen verwerfen",
    "noOptionsAvailable": "Keine Optionen verfügbar",
    "Instructions": "Anleitung",
    "add": "Hinzufügen",
    "search": "Suchen",
    "searchOrCreate": "Suchen oder erstellen...",
    "noResults": "Keine Ergebnisse gefunden.",
    "uploading": "Wird hochgeladen",
    "uploadingEllipsis": "Wird hochgeladen...",
    "or": "Oder",
    "you": "Du",
    "moreCount": "(+{{count}} weitere)",
    "dropzone": {
      "dragAndDrop": "Drag & Drop, oder",
      "clickToSelect": "Dateien auswählen",
      "maxFileSize": "Max. {{maxSize}} MB Dateien erlaubt",
      "rejectedType": "Nicht hinzugefügt – Dateityp nicht unterstützt: {{names}}",
      "rejectedSize": "Nicht hinzugefügt – größer als {{maxSize}} MB: {{names}}"
    },
    "notAvailable": "k. A.",
    "system": "System",
    "empty": "(leer)",
    "error": "Fehler",
    "excelUpload": {
      "downloadTemplateTitle": "Vorlage herunterladen",
      "downloadTemplateDesc": "Enthält genau diese Spalten – ausfüllen und hochladen.",
      "parsedRows": "{{count}} Zeilen eingelesen",
      "parseFailed": "Datei konnte nicht gelesen werden",
      "headerMismatch": "Keine Spalte entspricht der Vorlage. Bitte nutze die Spaltenüberschriften aus der Vorlage.",
      "dragOrBrowse": {
        "prefix": "Drag & Drop oder",
        "browse": "Dateien auswählen"
      },
      "maxFileSize": "Maximale Dateigröße: 10 MB"
    },
    "Workspaces": "Workspaces",
    "Help": "Hilfe"
  },
  "userTypes": {
    "system_admin": "Systemadministrator",
    "system_admin_description": "Vollständiger Systemzugriff und Konfiguration",
    "org_manager": "Organisationsmanager",
    "org_manager_description": "Organisationseinstellungen und Personen verwalten",
    "org_member": "Organisationsmitglied",
    "org_member_description": "Standardmitglied mit Basiszugriff",
    "partner_admin": "Partner-Admin",
    "partner_admin_description": "Verwaltet Leads, Team und Profil der Partner-Organisation",
    "partner_staff": "Partner-Mitarbeiter",
    "partner_staff_description": "Erfasst eigene Leads im Partnerbereich"
  },
  "userStatus": {
    "inactive": "Inaktiv",
    "pending": "Ausstehend",
    "active": "Aktiv",
    "suspended": "Gesperrt"
  },
  "userClassification": {
    "internal": "Interner Mitarbeiter",
    "external": "Externer Mitarbeiter",
    "internalShort": "Intern",
    "externalShort": "Extern"
  },
  "seatLimits": {
    "title": "Platzlimits",
    "systemAdmins": "Systemadministratoren",
    "orgManagers": "Organisationsmanager",
    "members": "Basisnutzer"
  },
  "bpmnEventTypes": {
    "none": "Manueller Start",
    "none_description": "Manuell von einer Person gestartet",
    "message": "Eingehende Anfrage",
    "message_description": "Ausgelöst durch eine eingehende Anfrage (z. B. E-Mail, Anruf oder Nachricht)",
    "timer": "Zeitpunkt / Frist",
    "timer_description": "Ausgelöst zu einem bestimmten Zeitpunkt oder nach einer Frist",
    "conditional": "Bedingt",
    "conditional_description": "Ausgelöst wenn eine Bedingung wahr wird",
    "signal": "Signal",
    "signal_description": "Ausgelöst durch eine Signalübertragung",
    "multiple": "Mehrfach",
    "multiple_description": "Mehrere Auslöser, einer ist erforderlich",
    "parallelMultiple": "Parallel Mehrfach",
    "parallelMultiple_description": "Mehrere Auslöser, alle sind erforderlich",
    "error": "Fehler",
    "error_description": "Ausgelöst durch einen Fehler",
    "cancel": "Abbruch",
    "cancel_description": "Ausgelöst wenn Transaktion abgebrochen wird",
    "escalation": "Eskalation",
    "escalation_description": "Ausgelöst durch eine Eskalation",
    "compensation": "Kompensation",
    "compensation_description": "Ausgelöst für Kompensationsbehandlung",
    "link": "Link",
    "link_description": "Verknüpft zu einem anderen Teil des Prozesses",
    "terminate": "Beenden",
    "terminate_description": "Beendet den Prozess sofort"
  },
  "pageTitles": {
    "home": "Startseite",
    "login": "Anmelden",
    "myTasks": "Meine Aufgaben",
    "myTasksWithCount": "Meine Aufgaben ({{count}})",
    "processDetail": "{{name}}",
    "processFlowFullscreen": "{{name}} - Fluss-Visualisierung",
    "allProcesses": "Alle Prozesse",
    "createProcesses": "Prozesse erstellen",
    "startRecording": "Aufzeichnung starten - {{name}}",
    "stepRecording": "Aufzeichnung - {{name}}",
    "orgMembers": "Personen",
    "orgMemberDetail": "{{name}}",
    "departments": "Abteilungen",
    "departmentDetail": "{{name}}",
    "mySystems": "Meine Systeme",
    "orgFunctionDetail": "{{name}}",
    "functions": "Funktionen",
    "teams": "Teams",
    "myOrgFunctions": "Meine Funktionen",
    "systems": "Systeme",
    "systemDetail": "{{name}}",
    "systemLandscape": "Systemlandschaft",
    "processMap": "Prozesslandkarte",
    "processChains": "Prozessketten",
    "processEditor": "Prozesseditor",
    "artifacts": "Unterlagen",
    "artifactDetail": "{{name}}",
    "externalContacts": "Externe Kontakte",
    "externalContactDetail": "{{name}}",
    "orgChart": "Organigramm",
    "settings": "Einstellungen",
    "tenants": "Mandanten",
    "departmentMembers": "Personen in meiner Abteilung",
    "departmentTeams": "Meine Abteilungsteams",
    "userManagement": "Benutzerverwaltung",
    "softwareList": "Softwareliste",
    "manageApps": "Apps verwalten",
    "dataSync": "Datenabgleich",
    "createDepartments": "Abteilungen erstellen",
    "dashboard": "Mein Arbeitsumfeld",
    "shadowSystems": "Schatten-Systeme",
    "help": "Kundenservice",
    "supportTickets": "Support-Tickets"
  },
  "noDashboardAccess": {
    "title": "Noch kein Zugriff auf einen Arbeitsbereich",
    "description": "Dein Konto hat keinen Zugriff auf eine Arbeitsbereichsansicht. Bitte wende dich an deine Administration, damit dir die passende Rolle zugewiesen wird."
  },
  "about": {
    "title": "Über BLIKS IO",
    "frontendVersion": "Frontend",
    "backendVersion": "Backend",
    "buildInfo": "Build"
  },
  "helpCenter": {
    "title": "Kundenservice",
    "subtitle": "Reiche eine Anfrage ein und verfolge deine Tickets",
    "contactUs": "Kontakt & Support",
    "contactSubtitle": "Nimm Kontakt mit unserem Support-Team auf",
    "viewTickets": "Meine Tickets",
    "openTicketsCount": "Offene Tickets: {{count}}",
    "ticketsWithNewReplyCount": "Tickets mit neuer Antwort: {{count}}",
    "contact": {
      "category": "Kategorie",
      "categoryPlaceholder": "Wie können wir dir helfen?",
      "categories": {
        "incident": "Problem melden",
        "request": "Anfrage stellen",
        "change": "Änderung beantragen",
        "complaint": "Beschwerde einreichen"
      },
      "summary": "Betreff",
      "summaryPlaceholder": "Kurze Zusammenfassung deiner Anfrage",
      "description": "Beschreibung",
      "descriptionPlaceholder": "Bitte beschreibe deine Anfrage im Detail...",
      "submit": "Anfrage absenden",
      "successTitle": "Anfrage eingereicht!",
      "successMessage": "Deine Anfrage wurde eingereicht. Unser Team meldet sich in Kürze bei dir.",
      "errorMessage": "Etwas ist schiefgelaufen. Bitte versuche es erneut oder kontaktiere {{supportEmail}}.",
      "newRequest": "Weitere Anfrage stellen",
      "ticketReference": "Ticket-Nummer: {{number}}",
      "attachmentsTitle": "Screenshots anhängen",
      "attachmentsHint": "Bis zu {{count}} Bilder, je max. {{size}} MB (PNG, JPEG, WebP)",
      "attachmentRemove": "{{name}} entfernen"
    }
  },
  "supportTickets": {
    "newReply": "Neue Antwort",
    "title": "Support-Tickets",
    "subtitle": "Sieh dir deine Support-Anfragen an",
    "loadErrorTitle": "Deine Tickets konnten nicht geladen werden",
    "loadError": "Der Support ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.",
    "empty": "Keine Tickets vorhanden",
    "emptyDescription": "Du hast noch keine Support-Tickets erstellt.",
    "open": "Offen",
    "closed": "Geschlossen",
    "status": {
      "received": "Eingegangen",
      "inProgress": "In Bearbeitung",
      "resolved": "Abgeschlossen",
      "merged": "Zusammengeführt"
    },
    "detail": {
      "title": "Support-Anfrage",
      "loadErrorTitle": "Die Anfrage konnte nicht geladen werden",
      "loadError": "Der Support ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.",
      "noMessages": "Zu dieser Anfrage gibt es noch keinen Nachrichtenverlauf.",
      "notLiveChat": "Kein Live-Chat – Antworten kommen hier und per E-Mail, in der Regel zeitnah.",
      "authorYou": "Du",
      "authorSupport": "Support",
      "replyLabel": "Antworten",
      "replyPlaceholder": "Schreibe eine Antwort an den Support...",
      "replySubmit": "Antwort senden",
      "sendShortcut": "⌘/Strg + Enter",
      "attach": "Bild anhängen",
      "replyError": "Deine Antwort konnte nicht gesendet werden. Bitte versuche es erneut.",
      "resolvedHint": "Diese Anfrage ist abgeschlossen. Ist noch etwas offen, kannst du sie erneut öffnen.",
      "mergedNotice": "Diese Anfrage wurde mit einer anderen Anfrage zusammengeführt und wird dort weiterbearbeitet.",
      "mergedLink": "Zur Anfrage #{{number}}",
      "reopenAction": "Anfrage erneut öffnen",
      "reopenLabel": "Was ist noch offen?",
      "reopenSubmit": "Senden und erneut öffnen",
      "attachmentDownload": "{{name}} herunterladen",
      "attachmentDownloadAction": "Herunterladen",
      "attachmentOpen": "{{name}} öffnen",
      "attachmentError": "Der Anhang konnte nicht geladen werden. Bitte versuche es erneut."
    }
  }
}
